// extracted by mini-css-extract-plugin
module.exports = {"HobbiesLogo":"HobbiesLogo_HobbiesLogo__2gCRg"};